"use client";
import React, {useEffect, useMemo, useState} from "react";
import {FontIcon} from "@/app/_components";
import SCIcon from "@/app/_components/SCIcon/SCIcon";
import {RedeemManager} from "@/Core/Redeem/RedeemManager";
import {LoginUIManager} from "@/Core/Login/LoginUIManager";
import {confJson} from "@/app/config/confJson";
import {useUser} from "@/app/context/UserContext";
import Load from "@/app/_components/Load/Load";
import {HttpResponse} from "@/Fwk/Http/HttpConfig";
import {DriveUtil} from "@/Master/DriveUtil";
import BigTips from "@/Master/BigTips";
import UserMgr from "@/Core/UserMgr";
import styles from "@/app/(redeem)/redeem.module.css";
import {RedeemResult} from "@/Core/Redeem/redeemEntity";
import {RedeemResultCode} from "@/Core/Redeem/redeemEnum";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {RedeemCashOutDialogFC} from "@/app/(redeem)/redeemCashOut/RedeemCashOutDialogFC";
import LoginNetManager from "@/Core/Login/LoginNetManager";
import {BaseInfo} from "@/Core/Login/types/user";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";

export default function RedeemCashOutUI() {
    const [loading, setLoading] = useState<boolean>(true);
    const [showTips, setShowTips] = useState(false);
    const [account, setAccount] = useState('');//提现帐号
    const [money, setMoney] = useState(0);//兑换金额
    const [currency, setCurrency] = useState('USD');//货币
    const [country, setCountry] = useState('');//国家
    const [state, setState] = useState('');//州
    const [city, setCity] = useState('');//城市
    const [zipCode, setZipCode] = useState('');//城市
    const [minMoney, setMinMoney] = useState(UserMgr.getGameCoreConfig.redeemScMin);//城市
    const user = useUser();

    const {scAvailableToRedeem} = user.baseInfo;


    const [checkData, setCheckData]  = useState<ResponseRedeemCheckData>({} as ResponseRedeemCheckData);

    const processFeeDollar = React.useMemo(
        () => {
            return DriveUtil.ToDollarString(checkData.feeRatio * money);
        },
        [checkData, money]
    );

    const dollar = React.useMemo(
        () => {
            const v = money - checkData.feeRatio * money;
            return DriveUtil.ToDollarString(v);
        },
        [checkData, money]
    );

    useEffect(() => {
        setAccount(RedeemManager.Instance.getChannelAccount);
        setCountry(RedeemManager.Instance.country);
        setState(RedeemManager.Instance.state);
        setCity(RedeemManager.Instance.city);
        setZipCode(LoginUIManager.getLastUserZipCode)
        getRedeemConfig();
    }, []);

    const getRedeemConfig: () => void = async () => {
        RedeemManager.CheckRedeemConfig((data:HttpResponse<ResponseRedeemCheckData>)=>{
            setLoading(false);
            if (data.data){
                setCheckData(data.data)
            }
        });
    }

    const onDoRedeem = () => {
        showForceLoading();
        RedeemManager.Instance.DoRedeem(money, (result) => {
            hideForceLoading();
            onRedeemCallBack(result);
        })
    }

    const onRedeemCallBack = (result: RedeemResult) => {
        switch (result.code) {
            case RedeemResultCode.NotZero:
                BigTips.showMsg("Not Zero");
                break;
            case RedeemResultCode.NoEnoughToMinRedeem:
                BigTips.showMsg("No Enough To Min Redeem");
                break;
            case RedeemResultCode.Ok:
                // SdkTrack.Track512Commit("redeem_amount_click", Util.NumberToString(sc, 3));
                showForceLoading();
                LoginNetManager.Instance.UpdateUserBaseInfo((data: BaseInfo) => {
                    SDialogManagerFC.closeDialogFC(RedeemCashOutDialogFC)
                    hideForceLoading();
                    //TODO UI逻辑：兑换成功
                    // RedeemSubmittedDialog.OpenDialogX(redeemResult.record);
                });
                break;
            case RedeemResultCode.ServerError:
                BigTips.showMsg(result.errorMessage);
                break;
            case RedeemResultCode.NoAvailableToRedeem:
                BigTips.showMsg("No Available To Redeem");
                break;
            default:
                BigTips.showMsg(result.code?.toString());
                break;
        }
    }

    if (!UserMgr.hasTokenOk(user.token))return <Load/>

    return (
        <div className={styles.redeem_cash_out_wrapper}>
            {/*{checkData && JSON.stringify(checkData)}*/}
            <div className={`redeemCashOut ${styles.redeemCashOut}`}>
                <section className={styles.section}>
                    <form>
                        <div className={`${styles.accountBox}`}>
                            <div className={`${styles.redeemInfo} center-left`}>
                                <div className={`${styles.avatar} center`}>
                                    <img src='/img/redeem/img_y_paypal.png'/>
                                    <div className={`${styles.iconPen} center`}>
                                        <FontIcon icon={'s-pen'} style={{color: '#fff',fontSize:'0.3rem'}}></FontIcon>
                                    </div>
                                </div>

                                <div className={`${styles.accountInfo}`}>
                                    <div className={`${styles.title}`}>Withdrawal Account:</div>
                                    <div className={`${styles.account}`}>{account}</div>
                                </div>
                            </div>

                            <div className={`${styles.redeemInfoBottom}`}>
                                <div className={`${styles.redeemInfoBottom_info}`}>Available to Redeem:<span className={`sc-color`}> {DriveUtil.ToScString(scAvailableToRedeem,true)}</span> </div>
                                <div className={`${styles.redeemInfoBottom_info} ${styles.redeemInfoBottom_info2} `}>Redeem to (minimum SC <span className={`err-color`}>{minMoney}</span>)</div>
                            </div>
                        </div>

                        <div className={`${styles.outBox} `}>
                            <div className={`center-left ${styles.eTitle}`}>Withdrawal Amount:</div>
                            <div className={`${styles.outAmount} center-left`}>
                                <div className={styles.outAmount_type}>
                                    <img src='/img/redeem/img_y_paypal.png' alt='PayPal'/>
                                </div>
                                <div className={styles.outAmount_input}>
                                    <input type='text' placeholder='Enter Redemption Amount'
                                           value={money}
                                           onChange={e => setMoney(Number(e.target.value))}
                                           />
                                    <div className={styles.outAmount_input_err}>Unplayed balance cannot be withdraw!</div>
                                </div>
                            </div>

                            <div className={`${styles.outInfo}`}>
                                <div className={`${styles.outInfo_item} center-space-between`}>
                                    <div className={`${styles.inf} ${styles.outInfo_txt1} center-left`}>
                                        <span>Processing free </span>
                                        <div className={`${styles.outInfo_tips} center`} onClick={()=>{setShowTips(!showTips)}}>
                                            <FontIcon icon={'s-sigh'}style={{color: '#3e1856', fontSize: '0.5rem'}}/>
                                            <div className={`${styles.outInfo_tipsDow} ${showTips ? 'show':'hide'}`}>
                                                <h3>HOW DO I EARN VIP POINTS?</h3>
                                                <section>Spin in any slot game</section>
                                                <section className={`center-left`}><SCIcon type="GC" cls={styles.outInfo_tipsDow_icon}/>100,000 =1 VIP POINT</section>
                                                <section className={`center-left`}><SCIcon cls={styles.outInfo_tipsDow_icon}/> 1 =1 VIP POINT</section>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${styles.inf} ${styles.outInfo_txt2}`}><span style={{fontWeight:'900',color:'#0090FF'}}>{processFeeDollar}</span></div>
                                </div>
                                <div className={`${styles.outInfo_item} center-space-between`}>
                                    <div className={`${styles.inf} ${styles.outInfo_txt1}`}>You'll Receive</div>
                                    <div className={`${styles.inf} ${styles.outInfo_txt2}`}>
                                        <span style={{fontWeight: '900', color: '#55FF3E'}}>{dollar}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* 提交按钮 */}
                        <button
                            type="button"
                            className={`btn ${styles.btn} ${styles.btn_cash_out_confirm}`}
                            onClick={onDoRedeem}
                        >
                            Confirm
                        </button>

                    </form>
                </section>
            </div>
        </div>
    )
}
